import { call, put, select } from 'typed-redux-saga'

import { AnyAction } from '@reduxjs/toolkit'
import services from '@services'
import { ApplicationState } from '@store/types'
import { DEFAULT_BIOMETRIC_ACTIVE, GetUseNewProvidersPayload } from '@store/biometria/types'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { StepRefin } from '@utils/enums'

import { setBiometricActive, setUseNewProviders } from '../actions'

export default function* getUseNewProvidersSaga(action: AnyAction) {
  const payload = action.payload as GetUseNewProvidersPayload

  const { accessToken } = yield* select((state: ApplicationState) => state.session)

  try {
    const response = yield* call(services.getUseNewProviders, accessToken)
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'getUseNewProviders' }))

    const value = response.data?.value as string | undefined
    const splitValue = value?.split(',')

    const shouldUseNewProviders = splitValue?.includes(payload.covenantId) ?? false

    if (!shouldUseNewProviders) {
      yield put(trackingRefin(StepRefin.NOT_USE_NEW_PROVIDERS))
      yield put(setUseNewProviders(false))
      yield put(setBiometricActive(DEFAULT_BIOMETRIC_ACTIVE))
    } else {
      yield put(trackingRefin(StepRefin.USE_NEW_PROVIDERS))
      yield put(setUseNewProviders(true))

      if (shouldUseNewProviders && payload?.onUseNewProviders) {
        payload.onUseNewProviders()
      }
    }
  } catch {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getUseNewProviders' }))
    yield put(trackingRefin(StepRefin.ERROR_GET_USE_NEW_PROVIDERS))
    yield put(setUseNewProviders(false))
    yield put(setBiometricActive(DEFAULT_BIOMETRIC_ACTIVE))
  }
}
